'use client';

import _slicedToArray from "/codebuild/output/src3059/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useRef, useEffect } from 'react';
function attachMediaListener(query, callback) {
  try {
    query.addEventListener("change", callback);
    return function () {
      return query.removeEventListener("change", callback);
    };
  } catch (e) {
    query.addListener(callback);
    return function () {
      return query.removeListener(callback);
    };
  }
}
function getInitialValue(query, initialValue) {
  if (typeof initialValue === "boolean") {
    return initialValue;
  }
  if (typeof window !== "undefined" && "matchMedia" in window) {
    return window.matchMedia(query).matches;
  }
  return false;
}
function useMediaQuery(query, initialValue) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      getInitialValueInEffect: true
    },
    getInitialValueInEffect = _ref.getInitialValueInEffect;
  var _useState = useState(getInitialValueInEffect ? initialValue : getInitialValue(query)),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  var queryRef = useRef();
  useEffect(function () {
    if ("matchMedia" in window) {
      queryRef.current = window.matchMedia(query);
      setMatches(queryRef.current.matches);
      return attachMediaListener(queryRef.current, function (event) {
        return setMatches(event.matches);
      });
    }
    return void 0;
  }, [query]);
  return matches;
}
export { useMediaQuery };